<template>
  <div>
    <v-card style="min-width: 100%">
      <v-card-title>
        <div class="d-flex">
          <div>
            <avatar-or-initials
              size="60"
              :name="data.group_detail.name"
              :image="data.group_detail.picture"
            ></avatar-or-initials>
          </div>
          <div>
            <div class="d-flex pt-2">
              <div
                class="Group-Title pl-2"
                @click="
                  goToGroup(data.group_detail.id, data.group_detail.group_type)
                "
              >
                {{ data.group_detail.name }}
              </div>
              <div class="pl-2">
                <img src="@/assets/crown.svg" width="25px" alt="" />
              </div>
            </div>
            <div>
              <div class="detail-Text pl-2">
                by
                <span
                  class="clickable-Name"
                  @click="goToProfile(data.group_detail)"
                >
                  {{ data.group_detail.admin.profile.name }}</span
                >
                (Admin)
              </div>
            </div>
          </div>
        </div>
      </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="6">
            <!-- Duration -->
            <div>
              <div class="DetailTitle-Text">Duration</div>
              <div
                class="DetailValue-Text text-capitalize"
                v-if="data.payment_data"
              >
                {{ data.payment_data.plan_detail.plan_name }}
              </div>
            </div>
            <!-- Duration end -->
            <br />
            <!-- Purchased Section -->
            <div>
              <div class="DetailTitle-Text">Purchased on</div>
              <div class="DetailValue-Text">
                {{ moment(data.start_date).format("DD-MMM-YYYY") }}
              </div>
            </div>
            <!-- Purchased Section End -->
          </v-col>
          <v-col cols="6" class="text-right">
            <!-- Price -->
            <div>
              <div class="DetailTitle-Text">Price</div>
              <div class="DetailValue-Text" v-if="data.payment_data">
                ₹{{ data.payment_data.total_price }}
              </div>
            </div>
            <!-- Price end -->
            <br />
            <!-- Expiry Date Section -->
            <div>
              <div class="DetailTitle-Text">Expiry Date</div>
              <div class="DetailValue-Text">
                {{ moment(data.end_date).format("DD-MMM-YYYY") }}
              </div>
            </div>
            <!-- Expiry Date Section End -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "MembershipCard",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    AvatarOrInitials: () => import("@/components/AvatarOrInitials"),
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    goToProfile(item) {
      if (item.is_admin) {
        this.$router.push({
          name: "ProfilePage",
        });
      } else {
        this.$router.push({
          name: "OthersProfilePage",
          params: {
            id: item.admin.id,
            name: item.admin.profile.name,
          },
        });
      }
    },
    goToGroup(id, group) {
      this.$router.push({
        name: group == "Premium" ? "premiumGroup" : "GroupDetails",
        params: {
          id: id,
        },
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.Group-Title {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  color: #333333;
  cursor: pointer;
}
.detail-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */

  color: rgba(51, 51, 51, 0.87);
}
.clickable-Name {
  color: #2d8cff;
  cursor: pointer;
}
.DetailTitle-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  /* identical to box height */

  color: rgba(51, 51, 51, 0.7);
}
.DetailValue-Text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;

  color: #333333;
}
</style>
